import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import PromoApi from "mbpromo/src/api/PromoApi";
import Constants from "../business/Constants";
import UrlHelper from "../helpers/url.helper";

class HaiVintoCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.init();
	}
	init() {
		this.loadChildComponents(this);
		this.startLoader();
		let pt = UrlHelper.getUrlParam("pt");
		if(pt){
			let promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
			promoApi.areaPersonale().then((resp)=>{
				const body = resp.body;
				const winCodes = body.response.data.receipts.filter(c =>  c.status === "WIN" && c.playdata.play_token === pt);

				if(winCodes.length > 0){
					const pm = UrlHelper.getUrlParam("pm");

					$('#premio-visual').fadeIn(300);
					$('#richiedi-premio').attr("href","/promozioni/mulino-mattoncino/completa-dati?pt="+pt+"&pm="+pm);
					this.removeLoader();
				}else{
					window.location.href = '/promozioni/mulino-mattoncino/non-hai-vinto'
				}
			});
		}else{
			//TODO Gestire errore no parametri
		}
	}


	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
	}

}

export default HaiVintoCtrl;
